import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_XS, SYS_BREAKPOINT_2_XL } from '../tokens/sizing.generated.js';
export const breakpointsMap = {
    xs: SYS_BREAKPOINT_XS,
    sm: SYS_BREAKPOINT_SM,
    md: SYS_BREAKPOINT_MD,
    lg: SYS_BREAKPOINT_LG,
    xl: SYS_BREAKPOINT_XL,
    xxl: SYS_BREAKPOINT_2_XL
};
//# sourceMappingURL=breakpoints.js.map